import { ResidencePermit } from "../../forms/Denmark/LoanApplication/config/globals";

export const getResidencePermitOptions = (typeOfResidence: ResidencePermit) => {
  let options: string[] = [];

  if (typeOfResidence === ResidencePermit.Temporary) {
    options = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'R', 'Z'];
  }

  if (typeOfResidence === ResidencePermit.Permanent) {
    options = ['B', 'D', 'H', 'L'];
  }

  return options.map((option) => ({ text: option, value: option }));
};
